import React from "react";
import { Box } from "@mui/material";
import Img1 from "./logos/img1.png";
import Img2 from "./logos/img3.png";
import Img3 from "./logos/img5.png";
import Img4 from "./logos/img5.png";
import Img5 from "./logos/img6.png";
import Img6 from "./logos/img7.png";
import Img7 from "./logos/img8.png";
import Img8 from "./logos/img9.png";
import Img11 from "./logos/Raipur-Logo.webp";
import Halsca from "./logos/halsca.webp";
import Phasal from "./logos/phasal.webp";
import CG from "./logos/CG.webp";
import Chips from "./logos/Chips.webp";
import Gem from "./logos/Gem.webp";
import StartupIndia from "./logos/Startup-India.webp";
import Marquee from "react-fast-marquee";

const logos = [
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
  { img: CG },
  { img: Halsca },
  { img: Phasal },
  { img: Img11 },
];

const Section11 = () => {
  return (
    <Box
      sx={{
        marginBottom: {
          xl: "22px",
          lg: "22px",
          md: "22px",
          sm: "0px",
          xs: "0px",
        },
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
      }}
    >
      <Marquee pauseOnHover={true}
        style={{
          maskImage: 'linear-gradient(to right, transparent, black 10% 90%, transparent)',
          width: '70%',
        }}
      >
        {logos.map((logo, index) => (
          <Box
            key={index}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              mx: "20px",
              "&:hover img": {
                filter: "grayscale(0%)", // Colorful on hover
              },
              "& img": {
                transition: "filter 0.3s ease", // Smooth filter transition
              },
            }}
          >
            <Box
              component="img"
              src={logo.img}
              alt={`logo-${index}`}
              sx={{
                height: { xl: 80, lg: 80, md: 80, sm: 56, xs: 52 },
                width: { xl: 80, lg: 80, md: 80, sm: 56, xs: 52 },
                borderRadius: "8px",
                mb: "40px",
                filter: "grayscale(100%)", // Black and white by default
                transition: "filter 0.3s ease", // Smooth filter transition
              }}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default Section11;